import { CERTIFICATION, COLOR, COUNT, MATERIAL_COMP, YARN_FIBER, YARN_OTHERS1, QUALITY, YARN_TECHNIQUE, 
         YARN_TEXTURE, YARN_TPYE, COLOR_COMP, FABRIC_WEAVE, FABRIC_TEXTURE, COLOR_DEPTH, TRIMS_TYPE, 
         TRIMS_MATERIAL, TRIMS_PROCESSING, TRIMS_PRINT, PACKING_MATERIAL_TYPE, 
         PACKING_MATERIAL_PRINT, PACKING_MATERIAL_MATERIAL, 
         DYE_INPUT, DYE_INPUT_SPEC, LIGHT_SOURCE, DYE_TYPE, WEAVE_SELVEDGE,
         PRODUCT, HARDGOOD, TYPE, WEAVE_PATTERN, WEAVE_REED_MARK,
         STORAGE, TRANSPORT_MODE, SPECIAL_FINISHING_TYPE} from "./specs.constants";

export type SpecProps = {
    data: any
}

export type SpecListItem = {
    fieldObject: string,
    fieldName: string,
    items?: any,
    type?: string
}

export const MATERIAL_SPECS_MAP: { [key: string]: any } = {
    'Yarn': [{
        fieldObject: 'spec1',
        type: 'select',
        items: COUNT,
        fieldName: 'Count'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: COLOR,
        fieldName: 'Color'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: MATERIAL_COMP,
        fieldName: 'Material Comp'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'CSP'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: CERTIFICATION,
        fieldName: 'Certification'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: YARN_TPYE,
        fieldName: 'Type'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: YARN_TECHNIQUE,
        fieldName: 'Technique'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: YARN_TEXTURE,
        fieldName: 'Texture'
    }, {
        fieldObject: 'spec9',
        type: 'select',
        items: QUALITY,
        fieldName: 'Quality'
    }, {
        fieldObject: 'spec10',
        type: 'select',
        items: YARN_FIBER,
        fieldName: 'Fiber'
    }, {
        fieldObject: 'spec11',
        type: 'select',
        items: YARN_OTHERS1,
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 2'
    }],
    'Fabric': [{
        fieldObject: 'spec1',
        type: 'select',
        items: COUNT,
        fieldName: 'Warp Count 1'
    }, {
        fieldObject: 'spec15',
        type: 'select',
        items: COUNT,
        fieldName: 'Warp Count 2'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: COUNT,
        fieldName: 'Weft Count'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'Reed'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Pick'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'GSM'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: COLOR_COMP,
        fieldName: 'Color Comp'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: FABRIC_WEAVE,
        fieldName: 'Weave'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: FABRIC_TEXTURE,
        fieldName: 'Texture'
    }, {
        fieldObject: 'spec9',
        type: 'select',
        items: MATERIAL_COMP,
        fieldName: 'Material Comp'
    }, {
        fieldObject: 'spec10',
        type: 'select',
        items: QUALITY,
        fieldName: 'Quality'
    }, {
        fieldObject: 'spec11',
        type: 'select',
        items: CERTIFICATION,
        fieldName: 'Certification'
    }, {
        fieldObject: 'spec12',
        type: 'select',
        items: COLOR_DEPTH,
        fieldName: 'Color Depth'
    }, {
        fieldObject: 'spec13',
        type: 'select',
        items: COLOR,
        fieldName: 'Color'
    }, {
        fieldObject: 'spec14',
        type: 'number',
        fieldName: 'Width (Inch)'
    }],
    'Trim': [{
        fieldObject: 'spec1',
        type: 'select',
        items: TRIMS_TYPE,
        fieldName: 'Type'
    }, {
        fieldObject: 'spec2',
        type: 'number',
        fieldName: 'Size (Cm)'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'Area (Sq Cm)'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: TRIMS_MATERIAL,
        fieldName: 'Material'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'GSM'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: TRIMS_PROCESSING,
        fieldName: 'Processing'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'Thickness (Micron)'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: TRIMS_PRINT,
        fieldName: 'Print'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Quality'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 3'
    }],
    'Packing Material': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PACKING_MATERIAL_TYPE,
        fieldName: 'Type'
    }, {
        fieldObject: 'spec2',
        type: 'number',
        fieldName: 'Width (Cm)'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'GSM'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Thickness (Micron)'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: PACKING_MATERIAL_PRINT,
        fieldName: 'Print'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        fieldName: 'Quality'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: PACKING_MATERIAL_MATERIAL,
        fieldName: 'Material'
    }, {
        fieldObject: 'spec8',
        type: 'number',
        fieldName: 'Ply'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Size'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 3'
    }],
    'Made-up': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Product'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: COLOR,
        fieldName: 'Color'
    }, {
        fieldObject: 'spec3',
        type: 'input',
        fieldName: 'Size'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Pc/Pack'
    }, {
        fieldObject: 'spec5',
        type: 'input',
        fieldName: 'Construction'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        fieldName: 'Composition'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'GSM'
    }, {
        fieldObject: 'spec8',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 4'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 5'
    }],
    'Hard Good': [{
        fieldObject: 'spec1',
        type: 'select',
        items: HARDGOOD,
        fieldName: 'Product'
    }, {
        fieldObject: 'spec2',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec3',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec4',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec5',
        type: 'input',
        fieldName: 'Others 4'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        fieldName: 'Others 5'
    }, {
        fieldObject: 'spec7',
        type: 'input',
        fieldName: 'Others 6'
    }, {
        fieldObject: 'spec8',
        type: 'input',
        fieldName: 'Others 7'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 8'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 9'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 10'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 11'
    }]
};

export const PROCESS_SPECS_MAP: { [key: string]: any } = {
    'Dyeing': [{
        fieldObject: 'spec1',
        type: 'select',
        items: DYE_INPUT,
        fieldName: 'Input'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: DYE_INPUT_SPEC,
        fieldName: 'Input Spec'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'GSM'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: COLOR,
        fieldName: 'Color'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Input Width (Inch)'
    }, {
        fieldObject: 'spec6',
        type: 'number',
        fieldName: 'Output Width (Inch)'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'Wash Fastness'
    }, {
        fieldObject: 'spec8',
        type: 'number',
        fieldName: 'Dry Rub Fastness'
    }, {
        fieldObject: 'spec9',
        type: 'number',
        fieldName: 'Wet Rub Fastness'
    }, {
        fieldObject: 'spec10',
        type: 'number',
        fieldName: 'Light Fastness'
    }, {
        fieldObject: 'spec11',
        type: 'select',
        items: LIGHT_SOURCE,
        fieldName: 'Light Source'
    }, {
        fieldObject: 'spec12',
        type: 'select',
        items: DYE_TYPE,
        fieldName: 'Type'
    }],
    'Weaving': [{
        fieldObject: 'spec1',
        type: 'number',
        fieldName: 'End/Inch'
    }, {
        fieldObject: 'spec2',
        type: 'number',
        fieldName: 'Pick/Inch'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'Reed Width (Mtr)'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Fabric Width (Mtr)'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Reed Count'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: WEAVE_PATTERN,
        fieldName: 'Pattern'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: WEAVE_SELVEDGE,
        fieldName: 'Selvedge'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: WEAVE_REED_MARK,
        fieldName: 'Reed Mark'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 4'
    }],
    /*'Transport': [{
        fieldObject: 'spec1',
        type: 'select',
        items: TRANSPORT_MODE,
        fieldName: 'Mode'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: ['LFH Home', 'Transporter'],
        fieldName: 'Loader'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['LFH Home', 'Transporter'],
        fieldName: 'Unloader'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['Everyday', 'Weekdays'],
        fieldName: 'Availability'
    }, {
        fieldObject: 'spec5',
        type: 'input',
        fieldName: 'Volume (Cu Mtr)'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        fieldName: 'Distance (Km)'
    }, {
        fieldObject: 'spec7',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec8',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 4'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 5'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 6'
    }],*/
    'Stitching': [{ fieldObject: 'spec1', type: 'select', items: ['NA', 'Normal', 'High Speed'], fieldName: 'Machine' }, 
                  { fieldObject: 'spec2', type: 'select', items: ['Basic', 'Customised', 'Commodity', 'Value Added'], fieldName: 'Item Type'}, 
                  { fieldObject: 'spec3', type: 'select', items: ['NA', 'Cotton', 'Polycotton', 'Polyester'], fieldName: 'Thread'}, 
                  { fieldObject: 'spec4', type: 'select', items: ['NA', 'Double Needle', 'Manual', 'Single Needle', 'Spreader'], 
                    fieldName: 'Stitching Method'}, 
                  { fieldObject: 'spec5', type: 'select', items: ['NA', 'Machine', 'Manual', 'Spreader'], fieldName: 'Cutting Method'}, 
                  { fieldObject: 'spec6', type: 'select', items: STORAGE, fieldName: 'Storage' }, 
                  { fieldObject: 'spec7', type: 'select', items: TRANSPORT_MODE, fieldName: 'Transport Mode' }, 
                  { fieldObject: 'spec8', type: 'input', fieldName: 'Others 1' }, 
                  { fieldObject: 'spec9', type: 'input', fieldName: 'Others 2' }, 
                  { fieldObject: 'spec10', type: 'input', fieldName: 'Others 3' }, 
                  { fieldObject: 'spec11', type: 'input', fieldName: 'Others 4' }, 
                  { fieldObject: 'spec12', type: 'input', fieldName: 'Others 5' }],
    'Cutting + Stitching': [{ fieldObject: 'spec1', type: 'select', items: ['NA', 'Normal', 'High Speed'], fieldName: 'Machine' }, 
                  { fieldObject: 'spec2', type: 'select', items: ['Basic', 'Customised', 'Commodity', 'Value Added'], fieldName: 'Item Type'}, 
                  { fieldObject: 'spec3', type: 'select', items: ['NA', 'Cotton', 'Polycotton', 'Polyester'], fieldName: 'Thread'}, 
                  { fieldObject: 'spec4', type: 'select', items: ['NA', 'Double Needle', 'Manual', 'Single Needle', 'Spreader'], 
                    fieldName: 'Stitching Method'}, 
                  { fieldObject: 'spec5', type: 'select', items: ['NA', 'Machine', 'Manual', 'Spreader'], fieldName: 'Cutting Method'}, 
                  { fieldObject: 'spec6', type: 'select', items: STORAGE, fieldName: 'Storage' }, 
                  { fieldObject: 'spec7', type: 'select', items: TRANSPORT_MODE, fieldName: 'Transport Mode' }, 
                  { fieldObject: 'spec8', type: 'input', fieldName: 'Others 1' }, 
                  { fieldObject: 'spec9', type: 'input', fieldName: 'Others 2' }, 
                  { fieldObject: 'spec10', type: 'input', fieldName: 'Others 3' }, 
                  { fieldObject: 'spec11', type: 'input', fieldName: 'Others 4' }, 
                  { fieldObject: 'spec12', type: 'input', fieldName: 'Others 5' }],
    'Cutting + Stitching + Checking': [{ fieldObject: 'spec1', type: 'select', items: ['NA', 'Normal', 'High Speed'], fieldName: 'Machine' }, 
                  { fieldObject: 'spec2', type: 'select', items: ['Basic', 'Customised', 'Commodity', 'Value Added'], fieldName: 'Item Type'}, 
                  { fieldObject: 'spec3', type: 'select', items: ['NA', 'Cotton', 'Polycotton', 'Polyester'], fieldName: 'Thread'}, 
                  { fieldObject: 'spec4', type: 'select', items: ['NA', 'Double Needle', 'Manual', 'Single Needle', 'Spreader'], 
                    fieldName: 'Stitching Method'}, 
                  { fieldObject: 'spec5', type: 'select', items: ['NA', 'Machine', 'Manual', 'Spreader'], fieldName: 'Cutting Method'}, 
                  { fieldObject: 'spec6', type: 'select', items: STORAGE, fieldName: 'Storage' }, 
                  { fieldObject: 'spec7', type: 'select', items: TRANSPORT_MODE, fieldName: 'Transport Mode' }, 
                  { fieldObject: 'spec8', type: 'input', fieldName: 'Others 1' }, 
                  { fieldObject: 'spec9', type: 'input', fieldName: 'Others 2' }, 
                  { fieldObject: 'spec10', type: 'input', fieldName: 'Others 3' }, 
                  { fieldObject: 'spec11', type: 'input', fieldName: 'Others 4' }, 
                  { fieldObject: 'spec12', type: 'input', fieldName: 'Others 5' }],
    'Vacuum Packing': [{
        fieldObject: 'spec1',
        type: 'select',
        items: ['Box Cushion', 'Chair Pad', 'Cushion', 'Pillow', 'Pouffe'],
        fieldName: 'Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: ['NA', 'Hand Pressed', 'Machine Pressed', 'Vacuum Suction'],
        fieldName: 'Method'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: STORAGE,
        fieldName: 'Storage'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Packing'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Box Sealing'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec7',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec8',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 4'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 5'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 6'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 7'
    }],
    'Filling': [{
        fieldObject: 'spec1',
        type: 'select',
        items: ['Box Cushion Panel', 'Chair Pad Panel', 'Cushion Panel', 'Pillow Panel', 'Pouffe Panel'],
        fieldName: 'Input Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: ['Box Cushion', 'Chair Pad', 'Cushion', 'Pillow', 'Pouffe'],
        fieldName: 'Output Item'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['NA', 'Blow', 'Manual'],
        fieldName: 'Filling Method'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['NA', 'Carding', 'Manual'],
        fieldName: 'Opening Method'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Filling Weight (Gm)'
    }, {
        fieldObject: 'spec6',
        type: 'input',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Mouth Closing'
    }, {
        fieldObject: 'spec7',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec8',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 4'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 5'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 6'
    }],
    'Printing': [{
        fieldObject: 'spec1',
        type: 'select',
        items: ['NA', 'All Over', 'Digital', 'Flat Bed Design', 'Khadi Design', 'Metallic Design', 'Panel Setting'],
        fieldName: 'Design'
    }, {
        fieldObject: 'spec2',
        type: 'number',
        fieldName: 'Input Width (Inch)'
    }, {
        fieldObject: 'spec3',
        type: 'number',
        fieldName: 'Output Width (Inch)'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Wash Fastness'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Dry Rub Fastness'
    }, {
        fieldObject: 'spec6',
        type: 'number',
        fieldName: 'Wet Rub Fastness'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'Light Fastness'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: LIGHT_SOURCE,
        fieldName: 'Light Source'
    }, {
        fieldObject: 'spec9',
        type: 'select',
        items: ['Block', 'Digital', 'Flat Bed', 'Foam ', 'Foil', 'Glitter', 'Hand Screen', 'Rotary', 'Rubber'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec10',
        type: 'select',
        items: ['NA', 'Hard', 'Silky', 'Soft'],
        fieldName: 'Finish'
    }, {
        fieldObject: 'spec11',
        type: 'select',
        items: ['NA', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        fieldName: 'Screen #'
    }, {
        fieldObject: 'spec12',
        type: 'number',
        fieldName: 'Fabric GSM'
    }],
    'Sanforizing': [{
        fieldObject: 'spec1',
        type: 'number',
        fieldName: 'Input Width (Inch)'
    }, {
        fieldObject: 'spec2',
        type: 'number',
        fieldName: 'Output Width (Inch)'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['0', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        fieldName: 'Shrink %'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Wash Fastness'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Dry Rub Fastness'
    }, {
        fieldObject: 'spec6',
        type: 'number',
        fieldName: 'Wet Rub Fastness'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'Light Fastness'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: LIGHT_SOURCE,
        fieldName: 'Light Source'
    }, {
        fieldObject: 'spec9',
        type: 'select',
        items: ['NA', 'Auto Control', 'Manual Control'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec10',
        type: 'select',
        items: ['NA', 'Hard', 'Silky', 'Soft'],
        fieldName: 'Finish'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 2'
    }],
    'Hand Processing': [{
        fieldObject: 'spec1',
        type: 'input',
        fieldName: 'Input Size'
    }, {
        fieldObject: 'spec2',
        type: 'input',
        fieldName: 'Output Size'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['0', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        fieldName: 'Shrink %'
    }, {
        fieldObject: 'spec4',
        type: 'number',
        fieldName: 'Wash Fastness'
    }, {
        fieldObject: 'spec5',
        type: 'number',
        fieldName: 'Dry Rub Fastness'
    }, {
        fieldObject: 'spec6',
        type: 'number',
        fieldName: 'Wet Rub Fastness'
    }, {
        fieldObject: 'spec7',
        type: 'number',
        fieldName: 'Light Fastness'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: LIGHT_SOURCE,
        fieldName: 'Light Source'
    }, {
        fieldObject: 'spec9',
        type: 'select',
        items: ['NA', 'Adda Work', 'Hand Embroidery', 'Hand Quilting', 'Hand Washing'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec10',
        type: 'select',
        items: ['NA', 'Hard', 'Silky', 'Soft'],
        fieldName: 'Finish'
    }, {
        fieldObject: 'spec11',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Product'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 1'
    }],
    'Embroidery': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine', 'Manual'], fieldName: 'Method'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Rivet Fixing': [
        {fieldObject: 'spec1', type: 'select', items: ['Grommette', 'Rivet'], fieldName: 'Size'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Button Fixing': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Kaja Making': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Fusing': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Method'], fieldName: 'Method'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Quilting': [
        {fieldObject: 'spec1', type: 'select', items: ['Diamond', 'Straight'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Fringe Making': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine', 'Manual'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Double Knotted', 'Self Needle', 'Single Knotted'], fieldName: 'Method'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Ironing': [
        {fieldObject: 'spec1', type: 'select', items: ['Heat', 'Steam'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Mending': [
        {fieldObject: 'spec1', type: 'select', items: ['Small', 'Medium', 'Large'], fieldName: 'Size'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Stain Removing': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine', 'Manual'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Solvent', 'Steam'], fieldName: 'Method'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Box Making': [
        {fieldObject: 'spec1', type: 'select', items: ['Manual'], fieldName: 'Closing Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Picotin': [
        {fieldObject: 'spec1', type: 'select', items: ['Normal'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Cotton', 'Polycotton', 'Polyester'], fieldName: 'Thread'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Cutting': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine', 'Manual'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Multi Layer', 'Single Layer'], fieldName: 'Technique'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Special Washing': [
        {fieldObject: 'spec1', type: 'select', items: ['Enzyme Wash', 'Softner Wash', 'Stone Wash'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Special Coating': [
        {fieldObject: 'spec1', type: 'select', items: ['Acrylic Coating', 'Aluminium Coating', 'PU Lamination'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Special Finishing': [
        {fieldObject: 'spec1', type: 'select', items: SPECIAL_FINISHING_TYPE, fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Embossing': [
        {fieldObject: 'spec1', type: 'select', items: ['Machine'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 10'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 11'}
    ],
    'Overlocking': [
        {fieldObject: 'spec1', type: 'select', items: ['Baby', 'Normal'], fieldName: 'Type'},
        {fieldObject: 'spec2', type: 'select', items: ['Cotton', 'Polycotton', 'Polyester'], fieldName: 'Thread'},
        {fieldObject: 'spec3', type: 'select', items: ['High Speed', 'Low Speed'], fieldName: 'Machine'},
        {fieldObject: 'spec4', type: 'select', items: ['3 Thread', '5 Thread'], fieldName: 'Quality'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 8'}
    ],
    'Blanket Stitching': [
        {fieldObject: 'spec1', type: 'select', items: ['Cotton', 'Wool'], fieldName: 'Thread'},
        {fieldObject: 'spec2', type: 'select', items: ['Machine'], fieldName: 'Type'},
        {fieldObject: 'spec3', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec4', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec5', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 7'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 8'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 9'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 10'}
    ],
    'Checking + Packing (Fabric)': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: TYPE,
        fieldName: 'Method'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['NA', 'Assorted', 'Individual', 'Gift'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Box Making'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: ['NA', '100%', 'Random'],
        fieldName: 'Inspection Method'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: ['NA', '3rd Party', 'Inhouse'],
        fieldName: 'Inspector'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: ['NA', '1.5', '2.5', '4'],
        fieldName: 'AQL'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: STORAGE,
        fieldName: 'Storage'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 4'
    }],
    'Checking + Packing (Made-up)': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: TYPE,
        fieldName: 'Method'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['NA', 'Assorted', 'Individual', 'Gift'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Box Making'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: ['NA', '100%', 'Random'],
        fieldName: 'Inspection Method'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: ['NA', '3rd Party', 'Inhouse'],
        fieldName: 'Inspector'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: ['NA', '1.5', '2.5', '4'],
        fieldName: 'AQL'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: STORAGE,
        fieldName: 'Storage'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 4'
    }]
};

export const LABOR_SPECS_MAP: { [key: string]: any } = {
    'Checking': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: TYPE,
        fieldName: 'Method'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: TYPE,
        fieldName: 'Stain Removal'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: TYPE,
        fieldName: 'Mending'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: TYPE,
        fieldName: 'Alterations'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: ['NA', '100%', 'Random'],
        fieldName: 'Inspection Method'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: ['NA', '3rd Party', 'Inhouse'],
        fieldName: 'Inspector'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: ['NA', '1.5', '2.5', '4'],
        fieldName: 'AQL'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 4'
    }],
    'Packing': [{
        fieldObject: 'spec1',
        type: 'select',
        items: PRODUCT,
        fieldName: 'Item'
    }, {
        fieldObject: 'spec2',
        type: 'select',
        items: TYPE,
        fieldName: 'Method'
    }, {
        fieldObject: 'spec3',
        type: 'select',
        items: ['NA', 'Assorted', 'Individual', 'Gift'],
        fieldName: 'Type'
    }, {
        fieldObject: 'spec4',
        type: 'select',
        items: ['NA', 'Machine', 'Manual'],
        fieldName: 'Box Making'
    }, {
        fieldObject: 'spec5',
        type: 'select',
        items: ['NA', '100%', 'Random'],
        fieldName: 'Inspection Method'
    }, {
        fieldObject: 'spec6',
        type: 'select',
        items: ['NA', '3rd Party', 'Inhouse'],
        fieldName: 'Inspector'
    }, {
        fieldObject: 'spec7',
        type: 'select',
        items: ['NA', '1.5', '2.5', '4'],
        fieldName: 'AQL'
    }, {
        fieldObject: 'spec8',
        type: 'select',
        items: STORAGE,
        fieldName: 'Storage'
    }, {
        fieldObject: 'spec9',
        type: 'input',
        fieldName: 'Others 1'
    }, {
        fieldObject: 'spec10',
        type: 'input',
        fieldName: 'Others 2'
    }, {
        fieldObject: 'spec11',
        type: 'input',
        fieldName: 'Others 3'
    }, {
        fieldObject: 'spec12',
        type: 'input',
        fieldName: 'Others 4'
    }],
    'Bale Packing': [
        {fieldObject: 'spec1', type: 'select', items: ['Plastic', 'Jute'], fieldName: 'Material'},
        {fieldObject: 'spec2', type: 'select', items: ['One Side', 'Three Side'], fieldName: 'Stitching'},
        {fieldObject: 'spec3', type: 'select', items: ['Hand Pressed', 'Machine Pressed'], fieldName: 'Method'},
        {fieldObject: 'spec4', type: 'select', items: ['Jute', 'Plastic'], fieldName: 'Thread'},
        {fieldObject: 'spec5', type: 'select', items: ['NA', 'LDPE', 'Paper'], fieldName: 'Inner Packing'},
        {fieldObject: 'spec6', type: 'input', fieldName: 'Others 1'},
        {fieldObject: 'spec7', type: 'input', fieldName: 'Others 2'},
        {fieldObject: 'spec8', type: 'input', fieldName: 'Others 3'},
        {fieldObject: 'spec9', type: 'input', fieldName: 'Others 4'},
        {fieldObject: 'spec10', type: 'input', fieldName: 'Others 5'},
        {fieldObject: 'spec11', type: 'input', fieldName: 'Others 6'},
        {fieldObject: 'spec12', type: 'input', fieldName: 'Others 7'}
    ],
};
